import { render } from "./DialogModal.vue?vue&type=template&id=704b4c39"
import script from "./DialogModal.vue?vue&type=script&lang=js"
export * from "./DialogModal.vue?vue&type=script&lang=js"

import "./DialogModal.vue?vue&type=style&index=0&id=704b4c39&lang=css"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__